import policySettings from '@config/policy_setting.yml';
import { PolicySettings } from '../../policy';

export default function usePolicySetting(type: "information" | "kyc", key: "travel" | "pet" | "car" | "motor" | "vaccine"): PolicySettings {
  const settings = policySettings.default[type][key]
  return settings
}

